import { useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';

export const ZOOM_DURATION = 1000;

export const useZoomTo = () => {
  const reactFlow = useReactFlow();
  return useCallback(
    (x: number, y: number) => {
      const shiftX = 200;
      const shiftY = 100;
      reactFlow.setCenter(x + shiftX, y + shiftY, {
        zoom: 0.9,
        duration: ZOOM_DURATION,
      });
    },
    [reactFlow],
  );
};
